var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.imgList),function(item,index){return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imgList[index]),expression:"imgList[index]"}],key:index})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }